import { StorageService } from './storage.service';

export interface IUser {
    token: string;
    email: string;
    firstName: string;
    lastName: string;
}

export abstract class UserService {
    private _userKey = 'user';

    set userKey(key: string) {
        this._userKey = key;
    }

    constructor(private readonly storageService: StorageService) {}

    getUser<T extends IUser>(): T | undefined {
        return this.storageService.getItem(this._userKey);
    }

    setUser<T extends IUser>(user: T) {
        this.storageService.setItem(this._userKey, user);
    }

    removeUser() {
        this.storageService.removeItem(this._userKey);
    }
}
